import React, { useState } from "react";
import Header from './Header';
import Footer from './Footer';


const About = () => {
  const [open, setOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  const getServiceDetails = (id) => {
    switch (id) {
      case 'service1':
        return {
          title: 'Residential Interior Designer | FREE 2-3D Designing Services',
          description: 'The best residential interior designer in kolkata. Our designers meet the needs and expectations of the customer according to the specific requirements and preferences of the customer.',
          img: 'assets/images/service/howrah-kadamtala-2nd-bedroom.jpg',
          link: 'residential-interior-decoration_kolkata.html'
        };
      case 'service2':
        return {
          title: 'Affordable Luxury 1/2/3/4 BHK Apartment Interior Start 2 Lakh',
          description: 'Affordable cost best interior designers in Kolkata. 2/3/4 BHK apartments luxury interior services without compromising on quality. Best luxury home interior design end-to-end solutions',
          img: 'assets/images/service/false-ceiling-design.jpg',
          link: 'flat-interior-decoration-services.html'
        };
      case 'service3':
        return {
          title: 'Low Budget Best Commercial Interior Designers Kolkata',
          description: 'Best commercial interior designers in kolkata area, office, showroom, and retail store designing, and even project management. Achieve a beautiful and functional space even on low budget.',
          img: 'assets/images/service/receptions-table.jpg',
          link: 'commercial-interior-decoration-kolkata.html'
        };
      case 'service4':
        return {
          title: 'Reasonable Prices Best Office Interior Designers Kolkata',
          description: 'Great choice for reasonable prices and exceptional expertise in office interior design in Kolkata. Our designers delivering exceptional value for money while not compromising on quality.',
          img: 'assets/images/service/low-cost-office-interior.jpg',
          link: 'office-interior-decoration-services-kolkata.html'
        };
      case 'service5':
        return {
          title: 'Restaurant-Hotel Interior Designer Kolkata West Bengal',
          description: 'Pranati Interior Designers restaurant and hotel design inspire traditional modern foodies and travellers. our decoration, renovation one stop solutions to suit the clients\' needs and preferences.',
          img: 'assets/images/service/resturents-table-chairs.jpg',
          link: 'restaurantinteriordesignersinkolkata.html'
        };
      case 'service6':
        return {
          title: 'Industrial Interior Decorating Top Designers In Kolkata',
          description: 'Pranati Interior designers their expertise and experience in the field of Industrial interior renovation, decorating and who are highly sought after by clients for innovative creative design solutions.',
          img: 'assets/images/service/office-interior.jpg',
          link: 'hotel-interior_decoration_kolkata.html'
        };
      default:
        return null;
    }
  };

  const selectedServiceData = selectedService ? getServiceDetails(selectedService) : null;


  return (
    <>
    <div className="app">
      <Header />
   
    <div className="breadcumb-area black-opacity bg-img-6">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="breadcumb-wrap">
                        <h2>About Us</h2>
                        <ul>
                            <li><a href="index.html">Home</a></li>
                            <li>/</li>
                            <li>About Us</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
    
     <div className="service-area bg-1">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="section-title text-center">
                        <h2>Best Interior Designer Decorator Kolkata</h2>
                        <h3>Given the growing demand for quality interior design services in Kolkata with Affordable Price</h3>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-6 col-12 col-lg-4">
                    <div className="service-wrap">
                        <div className="service-img" onClick={() => setSelectedService('service1')}>
                            <img src="assets/images/service/howrah-kadamtala-2nd-bedroom.jpg" alt="residential interior designer kolkata"/>
                            <input type="checkbox" className="service-checkbox" defaultChecked={true} />
                        </div>
                        <div className="service-content">
                            <h4>Residential Interior Designer | FREE 2-3D Designing Services</h4>
                            <p>The best residential interior designer in kolkata. Our designers meet the needs ...</p>
                           
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 col-12 col-lg-4">
                    <div className="service-wrap">
                        <div className="service-img" onClick={() => setSelectedService('service2')}>
                            <img src="assets/images/service/false-ceiling-design.jpg" alt="2, 3, 4 bhk interior designer kolkata"/>
                            <input type="checkbox" className="service-checkbox" defaultChecked={true} />
                        </div>
                        <div className="service-content">
                            <h4>Affordable Luxury 1/2/3/4 BHK Apartment Interior Start 2 Lakh</h4>
                            <p>Affordable cost best interior designers in Kolkata. 2/3/4 BHK apartments luxury interior services ...</p>
                            
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 col-12 col-lg-4">
                    <div className="service-wrap">
                        <div className="service-img" onClick={() => setSelectedService('service3')}>
                            <img src="assets/images/service/receptions-table.jpg" alt="commercial interior designers kolkata"/>
                            <input type="checkbox" className="service-checkbox" defaultChecked={true} />
                        </div>
                        <div className="service-content">
                            <h4>Low Budget Best Commercial Interior Designers Kolkata</h4>
                            <p>Best commercial interior designers in kolkata area, office, showroom, and retail store designing, and even project management. Achieve a beautiful ...</p>
                           
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 col-12 col-lg-4">
                    <div className="service-wrap">
                        <div className="service-img" onClick={() => setSelectedService('service4')}>
                            <img src="assets/images/service/low-cost-office-interior.jpg" alt="office interior designers kolkata"/>
                            <input type="checkbox" className="service-checkbox" defaultChecked={true} />
                        </div>
                        <div className="service-content">
                            <h4>Reasonable Prices Best Office Interior Designers Kolkata</h4>
                            <p>Great choice for reasonable prices and exceptional expertise in office interior design in Kolkata. Our designers delivering exceptional ...</p>
                            
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 col-12 col-lg-4">
                    <div className="service-wrap">
                        <div className="service-img" onClick={() => setSelectedService('service5')}>
                            <img src="assets/images/service/resturents-table-chairs.jpg" alt="restaurant interior designer kolkata"/>
                            <input type="checkbox" className="service-checkbox" defaultChecked={true} />
                        </div>
                        <div className="service-content">
                            <h4>Restaurant-Hotel Interior Designer Kolkata West Bengal</h4>
                            <p>Pranati Interior Designers restaurant and hotel design inspire traditional modern foodies and travellers. our decoration, renovation one stop solutions to ...</p>
                            
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 col-12 col-lg-4">
                    <div className="service-wrap">
                        <div className="service-img" onClick={() => setSelectedService('service6')}>
                            <img src="assets/images/service/office-interior.jpg" alt="industrial interior designers kolkata"/>
                            <input type="checkbox" className="service-checkbox" defaultChecked={true} />
                        </div>
                        <div className="service-content">
                            <h4>Industrial Interior Decorating Top Designers In Kolkata</h4>
                            <p>Pranati Interior designers their expertise and experience in the field of Industrial interior renovation...</p>
                          
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    {selectedServiceData && (
        <div style={styles.overlay} onClick={() => setSelectedService(null)}>
            <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div style={styles.modalHeader}>
                    <h2>Service Details</h2>
                    <button style={styles.closeModal} onClick={() => setSelectedService(null)}>Show Details</button>
                </div>
                <div style={styles.modalBody}>
                    <div style={styles.modalImage}>
                        <img src={selectedServiceData.img} alt={selectedServiceData.title} style={styles.modalImageImg} />
                    </div>
                    <div style={styles.modalInfo}>
                        <h3>{selectedServiceData.title}</h3>
                        <p>{selectedServiceData.description}</p>
                        
                    </div>
                </div>
            </div>
        </div>
    )}

    <Footer />
    
    </div>
    </>
  );
};


const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999
  },
  modal: {
    background: "#fff",
    padding: "30px",
    borderRadius: "10px",
    width: "400px",
    maxWidth: "90%",
    boxShadow: "0 4px 20px rgba(0,0,0,0.3)"
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px"
  },
  closeModal: {
    border: "none",
    background: "transparent",
    fontSize: "16px",
    cursor: "pointer",
    color: "#e85d5d",
    fontWeight: "bold"
  },
  modalBody: {
    display: "flex",
    flexDirection: "column",
    gap: "20px"
  },
  modalImage: {
    textAlign: "center"
  },
  modalImageImg: {
    width: "100%",
    maxWidth: "300px",
    borderRadius: "10px"
  },
  modalInfo: {
    textAlign: "center"
  },
  readMoreLink: {
    display: "inline-block",
    marginTop: "10px",
    padding: "10px 20px",
    background: "#e85d5d",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "5px"
  },
  inputBox: {
    marginBottom: "15px"
  },
  submitButton: {
    width: "100%",
    padding: "12px",
    background: "#e85d5d",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
    marginTop: "10px"
  },
  closeButton: {
    width: "100%",
    padding: "10px",
    background: "#ccc",
    color: "#333",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "10px"
  }
};

export default About;




